import { useParams } from 'react-router-dom'

import { DatasetDetailsOperationBar, PageContainer } from '@/components'
import { config } from '@/config'

import { LossFactorsDetailsForm } from './components'
import { useLossFactorsDetails, useLossFactorsDetailsForm } from './hooks'

export const LossFactorsDetailsPage = () => {
  const { id } = useParams()

  const {
    datasetInfo,
    isFetching,
    allDatasetNames,
    updateDataset,
    archiveDataset,
    unArchiveDataset,
    removeDataset,
    lockDataset,
    cloneDataset,
    isUpdateDatasetInProgress,
    isCloneDatasetInProgress
  } = useLossFactorsDetails(+(id || ''))

  const {
    handleSubmitForm,
    formControl,
    isFormValid,
    formValues,
    isFormTouched
  } = useLossFactorsDetailsForm(updateDataset, datasetInfo)

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[
            { title: 'Library' },
            { title: 'Loss Factors', path: config.links.library.lossFactors },
            { title: datasetInfo?.name || '' }
          ]}
        />
      }
      menuBar={
        !datasetInfo ? null : (
          <DatasetDetailsOperationBar
            datasetInfo={datasetInfo}
            onArchiveDataset={archiveDataset}
            onUnArchiveDataset={unArchiveDataset}
            onLockDataset={lockDataset}
            onRemoveDataset={removeDataset}
            onCloneDataset={(datasetName, onSuccess) =>
              cloneDataset(datasetName, { onSuccess })
            }
            isCloneDatasetInProgress={isCloneDatasetInProgress}
            allDatasetNames={allDatasetNames}
            isLockDisabled={!isFormValid || isFormTouched}
            saveButton={{
              onClick: handleSubmitForm,
              isDisabled: !isFormTouched || isUpdateDatasetInProgress,
              isLoading: isUpdateDatasetInProgress
            }}
          />
        )
      }>
      <LossFactorsDetailsForm
        datasetInfo={datasetInfo}
        formControl={formControl}
        formValues={formValues}
        isSubmitInProgress={isUpdateDatasetInProgress}
      />
    </PageContainer>
  )
}
